import apiClient from './ApiClient.js';
import CryptoJS from "crypto-js";
const SECRET_KEY = "my_super_secret_key";

// Login Service Component
const loginService = {
  async execute(email, password) {
    const response = await apiClient.post('auth/login', { email, password });
    if (response.data.payload.twoFactorRequired) {
      return response.data;
    }
    const { token } = response.data.payload;
    tokenManager.set(token);
    return response.data;
  },

  async verify2fa(email, otp) {
    const response = await apiClient.post('auth/verify-2fa-otp', { email, otp });
    const { token } = response.data.payload;
    tokenManager.set(token);
    return response.data;
  }
};

// Password Reset Service Component
const passwordResetService = {
  async forgot(email) {
    const response = await apiClient.post('auth/forget-password', { email });
    return response.data;
  },

  async verify(email, otp) {
    const response = await apiClient.post('auth/verify-otp', { email, otp });
    return response.data;
  },

  async reset(email, newPassword, confirmPassword) {
    const response = await apiClient.post('auth/set-new-password', {
      email,
      newPassword,
      confirmPassword,
    });
    return response.data;
  }
};

// ============================================
// TOKEN MANAGEMENT COMPONENT
// ============================================
const tokenManager = {
  set(token) {
    localStorage.setItem('token', token);
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },

  get() {
    return localStorage.getItem('token');
  },

  remove() {
    localStorage.removeItem('token');
    delete apiClient.defaults.headers.common['Authorization'];
  },

  exists() {
    return !!localStorage.getItem('token');
  }
};




// ============================================
// AUTH STATUS COMPONENT
// ============================================
const authStatus = {
  isAuthenticated() {
    return tokenManager.exists();
  },

  logout() {
    tokenManager.remove();
    window.location.href = '/admin/login';
  }
};

// ============================================
// EXPORT COMPONENTS
// ============================================
export {
  loginService,
  passwordResetService,
  tokenManager,
  authStatus,
};

// ============================================
// LEGACY EXPORTS (for backward compatibility)
// ============================================
export const loginAdmin = loginService.execute;
export const verify2faOtp = loginService.verify2fa;
export const forgotPassword = passwordResetService.forgot;
export const verifyOtp = passwordResetService.verify;
export const resetPassword = passwordResetService.reset;
export const logoutAdmin = authStatus.logout;
export const getAuthToken = tokenManager.get;
export const isAuthenticated = authStatus.isAuthenticated;
